export const POSTHOG_SESSION_COOKIE_NAME = "remi-posthog-session-id";
export const POSTHOG_PROJECT_ID = "30464";
